import fetch from "../../auth/FetchInterceptor";

export const getSubscriptions = function () {
  return fetch({
    url: '/subscriptions',
    method: 'get',
  })
}

export const getSubscription = (subscriptionId) => {
  return fetch({
    url: `/subscriptions/${subscriptionId}`,
    method: 'GET',
  });
}

export const createSubscription = (data) => {
  return fetch({
    url: `/subscriptions`,
    method: 'POST',
    data,
  });
}

export const updateSubscription = (subscriptionId, data) => {
  return fetch({
    url: `/subscriptions/${subscriptionId}`,
    method: 'PUT',
    data,
  });
}

export const deleteSubscription = (subscriptionId) => {
  return fetch({
    url: `/subscriptions/${subscriptionId}`,
    method: 'DELETE',
  });
}